import { render, staticRenderFns } from "./IconProcess.vue?vue&type=template&id=12878ce0"
import script from "./IconProcess.vue?vue&type=script&lang=js"
export * from "./IconProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports